import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzu6d2uqen: FaireProductEntity = {
  token: "p_kzu6d2uqen",
  type: "product",
  name: "S'mores Hot Cocoa Single Serve Craft Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/dbfb785ea8501eebbc6a005b707b7d1ef5a23c51ad21b2aa84cdda6557a0f1d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26990ba65d661864d2ae07bb6ff679ebcb1e881e323ccf0f047f54efd1c1c32d.jpeg",
    "https://cdn.faire.com/fastly/82cb4baeefc6987257763d15cb78c4445f98ff6507bf931efc672dcabe66ff73.jpeg",
    "https://cdn.faire.com/fastly/798ad6c0ba54e33ad150630d7fb2db0b101909ab24a5b5849cebd0c728c4ca85.jpeg",
  ],
  priceDollars: 1.5,
  description:
    "S'mores Hot Cocoa Single Serve Craft Cocktail (or Mocktail) $1.50 each- Sold In quantities of 24 (Eligible For FREE Display Box Please Order Separately). \n\nNoble Mick's single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick's is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick's we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!",
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:01.723Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
